import * as React from 'react';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

const MUIInputRadio = ({value,children,...props}) => {
    return (
        <FormControlLabel value={value} control={<Radio />} label={children}  {...props}/>
    );
};
export default MUIInputRadio;